<script setup lang="ts">
import { onMounted } from 'vue'
import { apiFetch } from '@/api'

// Not linked from normal navigation. Visit /debug/sentry-test directly to confirm both the
// frontend and backend sides of the Sentry/Bugsink pipeline work end to end.
onMounted(async () => {
  await apiFetch('/api/sample-error')
  setTimeout(() => {
    throw new Error('frontend sample error for Sentry/Bugsink verification')
  }, 0)
})
</script>

<template>
  <div class="sentry-test-page">
    <h1>Sentry / Bugsink verification</h1>
    <p>Triggered a backend sample error and a frontend sample error. Check Bugsink for both.</p>
  </div>
</template>
